module.exports = __webpack_public_path__ + "img/logo_footer.dd9928fc.png";